import React, { FC, useRef } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheUIVideoPlayer } from '@repo/roche-ui';
import { AssetData } from '../../utils/asset/types';
import { rocheVideoPlayerTracking, TrackedPercentage } from '../../helpers/roche-video-player-tracking';
import { settings } from '../../helpers/roche-video-player-settings';
import { useTranslation } from '../../hooks/use-translation';
import { StoryblokService } from '../../services/storyblok';

type RocheUIVideoPlayerProps = BlokToComponentProps<{
  preview: AssetData;
  brightcove_video?: string;
  youtube_video?: string;
  caption?: string;
  copyright?: string;
  fullscreen?: boolean;
}>;

export const RocheVideoPlayer: FC<RocheUIVideoPlayerProps> = ({ blok, slot }): JSX.Element => {
  const brightcoveVideoId = blok.brightcove_video;
  const youtubeVideoId = blok.youtube_video;
  const caption = blok.caption;
  const copyright = blok.copyright;
  const service = brightcoveVideoId ? 'brightcove' : 'youtube';
  const videoId = brightcoveVideoId || youtubeVideoId;
  const fullscreen = blok.fullscreen;
  const playLabel = useTranslation('play');
  const pauseLabel = useTranslation('pause');
  const trackedVideoPercentages = useRef<TrackedPercentage>({});

  // We should not try poor this state into the RocheUIVideoPlayer, custom inline component:
  if (!videoId && StoryblokService.isInEditor()) {
    return (
      <div
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '2.39 / 1',
          backgroundColor: '#FF1F26',
          padding: '20px',
        }}
      >
        <p>Warning! You must provide either a Brightcove Video or a Youtube Video before publishing.</p>
      </div>
    );
  }

  return (
    <RocheUIVideoPlayer
      service={service}
      videoId={videoId}
      caption={caption}
      copyright={copyright}
      preview={blok.preview.filename}
      previewAlt={blok.preview.alt}
      fullscreen={fullscreen}
      brightcoveSettings={settings.brightcove}
      playLabel={playLabel}
      pauseLabel={pauseLabel}
      slot={slot}
      onVideoStateChange={(event) => rocheVideoPlayerTracking(event, trackedVideoPercentages, false)}
    />
  );
};
